module.exports = __webpack_public_path__ + "img/优秀案例背景.d2c78dd1.png";